import { Component } from '@angular/core';
import { typesSelected } from '../../dash.component';

@Component({
  selector: 'types-selector',
  templateUrl: './types-selector.component.html',
  styleUrls: ['./types-selector.component.css']
})
export class TypesSelectorComponent {
  typesSelected = typesSelected;

  onTypeChange() {
    localStorage.setItem('typesSelected', JSON.stringify(this.typesSelected));
    window.location.reload();
  }
}
